<template>
  <v-card>
    <v-alert
      class="my-3"
      :color="`${color} lighten-4`"
      border="left"
      colored-border
    >
      <v-card-text>
        <v-row v-if="isExpired">
          <v-col class="py-0">
            <v-chip class="label" label small color="red" text-color="white">
              Прострочено
            </v-chip>
          </v-col>
        </v-row>
        <v-row class="justify-space-between">
          <v-col>
            <h3 class="title">
              {{ item.service.title }}
              <ServiceRecurrenceLabel :value="item.recurrence" />
            </h3>
          </v-col>
          <v-col cols="1">
            <v-btn large icon @click="removeService">
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <DatePicker
              v-model="item.startFrom"
              label="Дата активації"
              :filled="false"
              @input="change"
            />
          </v-col>
          <v-col>
            <DatePicker
              v-model="item.payedTo"
              label="Сплачено до"
              :filled="false"
              @input="change"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <DatePicker
              v-model="item.stoppedFrom"
              label="Дата зупинення"
              :filled="false"
              @input="change"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="item.stoppedReason"
              label="Причина зупинення"
              :disabled="!item.stoppedFrom"
              placeholder="Зв'язатися з клієнтом, з'ясувати причину непродовження сервісу"
              :required="!!item.stoppedFrom"
              :hide-details="false"
              :error-messages="
                $v.partnershipStoppedReason.$error
                  ? errors.PARTNERSHIP_STOPPED_REASON
                  : []
              "
              class="hide-details"
              @input="$v.partnershipStoppedReason.$touch()"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <h3>
              <DecimalEditor
                v-model="item.price"
                label="Ціна"
                scale="2"
                @input="change"
              />
            </h3>
          </v-col>
          <v-col>
            <h3>
              <DecimalEditor readonly label="Сумма" scale="2" :value="amount" />
            </h3>
          </v-col>
          <v-col>
            <h3>
              <DecimalEditor
                readonly
                label="Кількість"
                :value="item.quantity"
              />
            </h3>
          </v-col>
          <v-col>
            <WriteOffWaySelect v-model="item.writeOffWay" @input="change" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-alert>
  </v-card>
</template>

<script>
import DecimalEditor from "@/components/DecimalEditor";
import WriteOffWaySelect from "@/components/enums/WriteOffWaySelect";
import DatePicker from "@/components/story/DatePicker";
import ServiceRecurrenceLabel from "@/components/enums/ServiceRecurrenceLabel.vue";
import { ERRORS } from "@/helpers";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  components: {
    DecimalEditor,
    WriteOffWaySelect,
    DatePicker,
    ServiceRecurrenceLabel,
  },
  props: ["item"],
  computed: {
    servicePeriodMonths() {
      if (!(this.item.service && this.item.recurrence)) {
        return 0;
      }
      if (!(this.item.startFrom && this.item.payedTo)) {
        return 0;
      }

      const yearStartFrom = new Date(this.item.startFrom).getFullYear();
      const yearPayedTo = new Date(this.item.payedTo).getFullYear();
      const monthStartFrom = new Date(this.item.startFrom).getMonth();
      const monthPayedTo = new Date(this.item.payedTo).getMonth();

      return (
        (monthPayedTo -
          monthStartFrom +
          1 +
          12 * (yearPayedTo - yearStartFrom)) /
        this.item.recurrence
      );
    },
    amount() {
      const period = this.servicePeriodMonths;
      if (!period) {
        return 0;
      }
      return this.item.price * period * this.item.quantity;
    },
    isExpired() {
      const today = Date.now();
      const payedTo = Date.parse(this.item.payedTo);
      return today > payedTo;
    },
    color() {
      return this.isExpired ? "red" : "green";
    },
    errors() {
      return {
        PARTNERSHIP_STOPPED_REASON: [ERRORS.REQUIRED],
      };
    },
    partnershipStoppedCondition() {
      if (this.item.stoppedFrom && !this.item.stoppedReason) {
        return true;
      } else {
        return false;
      }
    },
  },
  validations: {
    partnershipStoppedReason: {
      required: requiredIf(function() {
        return this.partnershipStoppedCondition;
      }),
    },
  },
  methods: {
    removeService() {
      this.$emit("remove");
    },
    change() {
      if (!this.item.stoppedFrom) {
        this.item.stoppedReason = "";
      }
      this.$emit("change");
    },
  },
};
</script>
